import React from 'react';
import { IonButton, IonButtons, IonIcon, IonSpinner, useIonToast } from '@ionic/react';
import { checkmark } from 'ionicons/icons';
import DynamicButton from 'components/buttons/DynamicButton';
import { Trans } from 'react-i18next';
import { MESSAGE_ALIVE_MS, MESSAGE_POSITION } from 'util/constants';

export enum ModalStates {
  PREPARATION,
  ANALYSING,
  ANALYSISERROR,
  ANALYSISDONE,
  SAVING,
}

interface AnalysisButtonProps {
  state: ModalStates;
  beginAnalysis: () => void;
}

const AnalysisButton: React.FC<AnalysisButtonProps> = ({ state, beginAnalysis }) => {
  const [present] = useIonToast();

  const handleAnalysisClick = async () => {
    try {
      await beginAnalysis();
    } catch (error) {
      if (typeof present === 'function') {
        present({
          message: `Analysis failed: ${
            error instanceof Error ? error.message : 'Unknown error'
          }`,
          duration: MESSAGE_ALIVE_MS,
          color: 'danger',
          position: MESSAGE_POSITION,
        });
      }
    }
  };

  if (state === ModalStates.ANALYSISDONE) {
    return (
      <IonButton
        expand="block"
        color="success"
        style={{ '--border-radius': '10px', borderRadius: '10px' }}
      >
        <IonIcon icon={checkmark} />
        <IonButton color="primary" fill="solid">
          <Trans i18nKey="ANALYZE">Analysieren</Trans>
        </IonButton>
      </IonButton>
    );
  }
  if (state === ModalStates.ANALYSING) {
    return (
      <IonButton expand="block" disabled>
        <IonSpinner name="crescent" color="white" />
      </IonButton>
    );
  }
  return (
    <IonButtons slot="start">
      <DynamicButton
        text={<Trans i18nKey="DISCARD">Analyze</Trans>}
        iconName="OKUpIcon"
        fill="clear"
        size="xlarge"
        style={{ borderRadius: '10px' }}
        onClick={handleAnalysisClick}
      />
    </IonButtons>
  );
};

export default AnalysisButton;